module.exports = __webpack_public_path__ + "static/media/17.7e5042b3.webp";